<setting-info>
	<div class="wrapper page" if={!isResigned}>
		<section class="page_wrap">
			<div class="page_inner">
				<h1 class="main_title page">登録情報</h1>
				
				<div class="info_wrap">
					<div class="bnr_info biz-id">
						<a href="{infourl}" target="_blank">
							<div class="bnr_info-title_wrap">
								<p class="bnr_info-title">会員登録情報の確認</p>
								<p class="bnr_info-subtitle">（CROCO IDの会員情報へ）</p>
							</div><!--/.bnr_info-title_wrap-->	
						</a>
					</div><!--/.bnr_info-->
					<div class="bnr_info">
						<a style="cursor:pointer" class="js-modal-open" data-target="resign-modal" onclick="{ (e) => onOpenModal(e, 'resign-modal') }">
							<div class="bnr_info-title_wrap">
								<p class="bnr_info-title">サービスの退会</p>
							</div><!--/.bnr_info-title_wrap-->		
						</a>
					</div><!--/.bnr_info-->
				</div><!--/.info_wrap-->
				
				
				
			</div><!--/.page_inner-->
		</section><!--page_wrap-->
	</div><!--/.wrapper-->
    <resign-modal modal-id="resign-modal"></resign-modal>
	<setting-resigned if={isResigned}></setting-resigned>
  <script>
    import di from "dependeny-injection";
    import resignModal from "@tags/modal/setting/resign-modal.riot";
    import settingResigned from "@tags/pages/setting/resigned.riot";
    import { api as SettingStausApi } from "@model/setting-status.js";

    export default {
		infourl: '',
		isResigned: false,
        components: {
            "resign-modal": resignModal,
			"setting-resigned": settingResigned
        },
        onBeforeMount(){
            SettingStausApi.on('resigned', (payload) => {
				if (!payload.result) {
					alert(payload.message);
					return;
				}
                this.isResigned = true;
                this.update();
            });

            SettingStausApi.on('fetched:infourl', (data) => {
                this.infourl = data;
                this.update();
            });
			SettingStausApi.fetchInfoUrl();
        },
        onOpenModal(e, modalId) {
            window.$(this.$(`#${modalId}`)).fadeIn(100);
        },
    }
  </script>
</setting-info>
